import React, { useEffect } from 'react';

const ResumeReview: React.FC = () => {
  useEffect(() => {
    document.title = 'OfferFlow | Resume Review';
  }, []);

  return (
    <div>
    </div>
  );
};

export default ResumeReview;
